import React from "react";
import "./HWork.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

import RNavbar from "../component/RNavbar";
import Calculator from "../component/Calculator";
import RFooter from "../component/RFooter";

import first from "../img/howWeWork/first.png";

import second from "../img/howWeWork/second.png";

import third from "../img/howWeWork/third.png";

import reward from "../img/howWeWork/reward.png";

import pm from "../img/howWeWork/pm.png";
import sqpm from "../img/sqpp.png";

import sms from "../img/howWeWork/sms.png";
import sqsms from "../img/howWeWork/sqsms.png";

import control from "../img/howWeWork/control.png";
import sqcontrol from "../img/howWeWork/sqcontrol.png";

import app from "../img/howWeWork/app.png";
import sqapp from "../img/howWeWork/sqapp.png";

import support from "../img/howWeWork/support.png";
import sqsupport from "../img/howWeWork/sqsupport.png";

import Connect from "../component/Connect";
import { useEffect } from "react";

function HWork() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="how-we-work">
      <RNavbar main="hww-heading" />
      <Connect />
      <div className="hww-heading">
        <h1>How our writing service works</h1>
        <p>
          Using our service is not rocket science, it’s easy as 1-2-3. PaperHelp
          company save your TIME on paper writing while you reach your true
          goals.
        </p>
      </div>
      <div className="test">
        <div className="order-c">
          <div className="order-heading">
            <h1>Order placement</h1>
            <p>Redundant alt attribute. Screen-readers already announce</p>
          </div>
          <div className="order-place">
            <div className="step">
              <div>
                <img src={first} alt="#1"></img>
              </div>
              <div className="step-text">
                <h2>Type of Paper</h2>
                <p>
                  Choose the right type of paper in the order form. It helps us
                  reach your expectations at the highest speed
                </p>
              </div>
            </div>
            <div className="step">
              <div>
                <img src={second} alt="#2"></img>
              </div>
              <div className="step-text">
                <h2>Paper Details</h2>
                <p>
                  Explain your assignment with as many details as you have.
                  Upload any extra files later in your control panel on the
                  order page. This way, the writer will know exactly what to
                  write about and what to include.
                </p>
              </div>
            </div>
            <div className="step">
              <div>
                <img src={third} alt="#3"></img>
              </div>
              <div className="step-text">
                <h2>Valid Email</h2>
                <p>
                  Please type only a valid email. Our system saves your time and
                  generates secure login information to help you log in to your
                  control panel faster and manage orders later. With an
                  incorrect email, your password will fall in the dark.
                </p>
              </div>
            </div>
            <div className="step">
              <div>
                <img src={reward} alt="#4"></img>
              </div>
              <div className="step-text">
                <h2>Secure Payment</h2>
                <p>
                  When the order form is complete, you proceed to secure payment
                  with your Credit Card or another payment system. All your
                  payments are safe and your payment details will never be
                  shared within or beyond our writing Galaxy.
                </p>
                <div className="payments">
                  <img src={pm} alt="payment methods"></img>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="track-c">
          <div className="track-heading">
            <h1>Track and Manage your Order</h1>
            <p>Redundant alt attribute. Screen-readers already announce</p>
          </div>

          <div className="track-main">
            <div className="ts">
              <LazyLoadImage
                alt="sms"
                effect="blur"
                src={sms}
                placeholderSrc={sqsms}
                width="60px"
                height="60px"
              />
              <h2>By Email or With SMS</h2>
              <p>
                Our rocket delivers you emails with all of your order updates.
                If you’re more comfortable with SMS, then you can receive them
                by adding the VIP Customer Service extra to your order.
              </p>
            </div>
            <div className="ts">
              <LazyLoadImage
                alt="control"
                effect="blur"
                src={control}
                placeholderSrc={sqcontrol}
                width="60px"
                height="60px"
              />
              <h2>In Your Control Panel</h2>
              <p>
                To learn what your order has been up to, you can log in to your
                personal space in our Galaxy. To get there, use your login
                details from the email you received while registering or placing
                your first order.
              </p>
            </div>
            <div className="ts">
              <LazyLoadImage
                alt="support"
                effect="blur"
                src={support}
                placeholderSrc={sqsupport}
                width="60px"
                height="60px"
              />
              <h2>From Support</h2>
              <p>
                Our Support Team is reachable 24/7. You have so many ways to get
                hold of them and ask about your order status – email, phone,
                chat, Facebook Messenger.
              </p>
            </div>
            <div className="ts">
              <LazyLoadImage
                alt="app"
                effect="blur"
                src={app}
                placeholderSrc={sqapp}
                width="60px"
                height="60px"
              />
              <h2>In Our App</h2>
              <p>
                Download our app and check notifications on the go on your
                Android device.
              </p>
            </div>
          </div>
        </div>

        <div className="paper-c">
          <div className="order-heading">
            <h1>Get Your Paper</h1>
            <p>Redundant alt attribute. Screen-readers already announce</p>
          </div>
          <div className="paper-main">
            <div className="paper">
              <h2>Get it checked in Turn it in with no risk</h2>
              <p>
                Your paper is original and exceptional just like the Universe.
                We use 2 different web scanners to provide 100% unique papers.
                You can also ask for Turnitin report without storing a paper to
                database -completely safe!
              </p>
            </div>
            <div className="paper">
              <h2>Leave your feedback and get a discount</h2>
              <p>
                Share your experience with others and get a 7% discount for your
                next order after the review is published. To earn such PaperHelp
                discount codes, ask our manager for the best review sites to
                visit.
              </p>
            </div>
            <div className="paper">
              <h2>Order more and get better prices</h2>
              <p>
                The more you order the more credits you get for your future
                assignments. Our Loyalty Program allows you to get credits to
                your balance from the sum paid with real money. Saved credits
                can be used on future orders.
              </p>
            </div>
          </div>
        </div>

        <div className="lp-heading">
          <h1>Loyalty Program</h1>
          <h2>ORDER MORE – GET BIGGER DISCOUNTS!</h2>
          <p>
            Get up to 15% in credits based on the number of pages in your order.
            Our win-win Loyalty Program gets you a credit for EACH order with
            pages. New credits will be counted only from the sum paid with real
            money.
          </p>
        </div>
      </div>
      <div className="hwork-calc">
        <Calculator />
      </div>

      <RFooter />
    </div>
  );
}

export default HWork;
